import React, { useState } from "react";
import { X } from "lucide-react";
import { toastError } from "../../utils";
import DateInput from "../DateInput";

const SearchFilter = ({
  onSearch,
  showItemName = true,
  showProductFilters = false,
}) => {
  const [searchBy, setSearchBy] = useState("name");
  const [searchValue, setSearchValue] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [expiryMonths, setExpiryMonths] = useState("1");
  const [stockValue, setStockValue] = useState("");

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    if (
      ["name", "itemName"].includes(searchBy) &&
      searchValue.trim().length < 2
    ) {
      return toastError("Minimum 2 characters required");
    }

    if (searchBy === "date" && (!dateFrom || !dateTo)) {
      return toastError("Select both dates");
    }

    if (searchBy === "minStockAlert" && !stockValue) {
      return toastError("Enter stock quantity");
    }

    let query = {};

    if (searchBy === "date") {
      query = { fromDate: dateFrom, toDate: dateTo };
    } else if (searchBy === "expiry") {
      query = { expiryMonths };
    } else if (searchBy === "minStockAlert") {
      query = { minStockAlert: stockValue };
    } else {
      query = { searchBy: JSON.stringify({ [searchBy]: searchValue }) };
    }

    onSearch({ query });
  };

  const handleClear = () => {
    setSearchBy("name");
    setSearchValue("");
    setDateFrom("");
    setDateTo("");
    setExpiryMonths("1");
    setStockValue("");
    onSearch({});
  };

  const hasValue =
    searchValue || dateFrom || dateTo || stockValue || searchBy === "expiry";

  const isDisabled =
    (["name", "itemName"].includes(searchBy) &&
      searchValue.trim().length < 2) ||
    (searchBy === "date" && (!dateFrom || !dateTo)) ||
    (searchBy === "minStockAlert" && !stockValue);

  return (
    <form onSubmit={handleSearchSubmit}>
      <div className="d-flex gap-2 align-items-center flex-wrap flex-md-nowrap">
        <select
          value={searchBy}
          onChange={(e) => {
            setSearchBy(e.target.value);
            setSearchValue("");
            setDateFrom("");
            setDateTo("");
            setStockValue("");
          }}
          className="border p-2 rounded"
        >
          <option value="name">Name</option>
          {showItemName && <option value="itemName">Item Name</option>}
          <option value="date">Date Range</option>
          {showProductFilters && (
            <>
              <option value="expiry">Expiry</option>
              <option value="minStockAlert">Low Stock</option>
            </>
          )}
        </select>

        {/* Date Range */}
        {searchBy === "date" && (
          <>
            <div style={{ minWidth: "180px" }}>
              <DateInput value={dateFrom} onChange={setDateFrom} />
            </div>

            <span>to</span>

            <div style={{ minWidth: "180px" }}>
              <DateInput value={dateTo} onChange={setDateTo} />
            </div>
          </>
        )}
        {/* Expiry Filter */}
        {showProductFilters && searchBy === "expiry" && (
          <select
            value={expiryMonths}
            onChange={(e) => setExpiryMonths(e.target.value)}
            className="border p-2 rounded"
          >
            <option value="1">Expiry in 1 Month</option>
            <option value="3">Expiry in 3 Months</option>
            <option value="5">Expiry in 5 Months</option>
            <option value="6">Expiry in 6 Months</option>
            <option value="12">Expiry in 12 Months</option>
          </select>
        )}

        {/* Low Stock */}
        {showProductFilters && searchBy === "minStockAlert" && (
          <input
            type="number"
            placeholder="Enter Qty"
            value={stockValue}
            onChange={(e) => setStockValue(e.target.value)}
            className="border p-2 rounded"
          />
        )}

        {/* Normal Search */}
        {["name", "itemName"].includes(searchBy) && (
          <div className="position-relative">
            <input
              type="text"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder={`Search by ${searchBy}`}
              className="border p-2 rounded"
            />

            {/* {searchValue && (
              <X
                className="position-absolute top-50 end-0 translate-middle-y me-2"
                size={16}
                onClick={handleClear}
                style={{ cursor: "pointer" }}
              />
            )} */}
          </div>
        )}

        <button
          type="submit"
          disabled={isDisabled}
          className="btn btn-custom btn-sm p-2"
        >
          Search
        </button>

        {hasValue && (
          <button
            type="button"
            onClick={handleClear}
            className="btn btn-secondary btn-sm p-2"
          >
            Clear
          </button>
        )}
      </div>
    </form>
  );
};

export default React.memo(SearchFilter);
